export default __webpack_public_path__ + "static/media/human.e5739c77.png";